module.exports = __webpack_public_path__ + "img/vector.80bbf75d.svg";